import React, { Component } from 'react';
import { connect } from 'react-redux';
import {fetchLogsByDeviceId} from '../../../actions/log';
import {appTitle, emptyObject, exists, WINDOW_WIDTH, DESKTOP_VIEW} from '../../../util/util';
import {MIN_WET_LOGS_TO_DISPLAY} from "../../../api/constants";
import CircularProgress from 'material-ui/CircularProgress';
import {Tabs, Tab} from 'material-ui/Tabs';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {AppBarMobile} from "admin-on-rest";
import {Bar} from 'react-chartjs-2';
import LogController from '../../../models/logs/logController';
import './DeviceLogsChart.css';

const TAB = {
  CHART_ID: 1,
  DETAILS_ID: 2
};

class DeviceLogsChart extends Component {
  
  constructor() {
    super();
    
    this.state = {
      wetLogsExist: false,
      currentTab: TAB.CHART_ID
    }
  }
  
  componentWillMount() {
    let deviceId = this.props.match.params.id;
    this.props.fetchLogsByDeviceId(deviceId);
  }
  
  render() {
    
    return(
      <div>
        {DESKTOP_VIEW || (<AppBarMobile title={appTitle()} />)}
        <div className="page-wrapper">
          {this._renderLoader()}
          {this._renderWetStatusLogs()}
        </div>
      </div>
    );
  }
  
  _renderLoader() {
    
    let loading = this.props.loading;
    
    if(loading)
      return(
        <div className="loaderWrapper">
          <CircularProgress size={80} thickness={7} />
        </div>
      )
  }
  
  _renderNoLogsMessage() {
    
    let wetLogsCount = LogController._countWetStatusLogs(this.props.logs);
    
    return(
      <div className="failedMessageWrapper">
        <p>No sufficient data to make recommendations.</p>
        <p>At least {MIN_WET_LOGS_TO_DISPLAY} incidents needs to be registered.</p>
        <p>{this._renderWetLogsCountMessage(wetLogsCount)}</p>
      </div>
    );
  }
  
  _renderWetLogsCountMessage(count) {
    
    switch(count) {
      case 0:
        return `${count} incidents registered at the moment.`;
      case 1:
        return `Only ${count} incident registered at the moment.`;
      default:
        return `Only ${count} incidents registered at the moment.`;
    }
  }
  
  _renderWetStatusLogs() {
    
    let loading = this.props.loading;
    
    if(!loading) {

      let wetLogsExist = LogController._wetLogsExist(this.props.logs);
      
      return(
        <div>
          {!wetLogsExist ? this._renderNoLogsMessage() : this._renderTabs()}
        </div>
      );
    }
  }
  
  _getChartData() {
  
    let data = LogController._setWetLogsRepeatingOccurrencesByHour(this.props.logs);
    
    let lineData = {
      type:'line',
      label: 'Changes',
      data: data,
      fill: false,
      borderColor: 'rgba(219, 0, 40, 0.7)',
      backgroundColor: 'rgba(219, 0, 40, 1)',
      pointBorderColor: 'rgba(219, 0, 40, 1)',
      pointBackgroundColor: 'rgba(219, 0, 40, 1)',
      pointHoverBackgroundColor: 'rgba(219, 0, 40, 1)',
      pointHoverBorderColor: 'rgba(219, 0, 40, 1)',
      yAxisID: 'y-axis-2'
    };
    
    let barData = {
      type: 'bar',
      label: 'Changes',
      data: data,
      fill: false,
      backgroundColor: 'rgba(58, 81, 139, 0.7)',
      borderColor: 'rgba(58, 81, 139, 1)',
      hoverBackgroundColor: 'rgba(58, 81, 139, 1)',
      hoverBorderColor: 'rgba(58, 81, 139, 1)',
      yAxisID: 'y-axis-1'
    };
  
    let wetLogsExist = LogController._wetLogsExist(this.props.logs);
    
    let datasets = wetLogsExist ? [lineData, barData] : [];
    
    return {
      labels: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00',
               '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],
      datasets: datasets
    };
  }
  
  _getChartOptions() {
    
    return {
      responsive: true,
      tooltips: {
        mode: 'nearest'
      },
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            type: 'linear',
            display: true,
            position: 'left',
            id: 'y-axis-1',
            gridLines: {
              display: false
            },
            labels: {
              show: true
            }
          },
          {
            type: 'linear',
            display: true,
            position: 'right',
            id: 'y-axis-2',
            gridLines: {
              display: false
            },
            labels: {
              show: true
            }
          }
        ]
      }
    };
  }
  
  _setChartWidth() {
    
    let pageWrapperElement = document.querySelector(".page-wrapper");
    
    if(exists(pageWrapperElement)) {
      
      let offsetWidth = pageWrapperElement.offsetWidth;
      
      if(exists(offsetWidth) && offsetWidth > 0) {
        
        if(WINDOW_WIDTH > 992) return offsetWidth - 100;
        return offsetWidth;
      }
      else{
        setTimeout(() => {
          this._setChartWidth();
        }, 300);
      }
    }
  }
  
  _renderTabs() {
    
    let chartData = this._getChartData();
    let chartOptions = this._getChartOptions();
    
    return (
      <Tabs
        value={this.state.currentTab}
        onChange={tabId => this._changeTab(tabId)}>
        <Tab label="Chart" value={TAB.CHART_ID}>
          <Bar data={chartData} options={chartOptions} />
        </Tab>
        <Tab label="Details" value={TAB.DETAILS_ID}>
          {this._renderWetLogsDetailsTable()}
        </Tab>
      </Tabs>
    );
  }
  
  _renderWetLogsDetailsTable() {
    return(
      <Table selectable={false}>
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}>
          <TableRow>
            <TableHeaderColumn>NO.</TableHeaderColumn>
            <TableHeaderColumn>DATE</TableHeaderColumn>
            <TableHeaderColumn>TIME</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
          stripedRows={true}>
          {this._renderWetLogsDetailRows()}
        </TableBody>
      </Table>
    );
  }
  
  _renderWetLogsDetailRows() {
    
    let logs = LogController._setWetLogsTimes(this.props.logs);
    
    if(logs && !emptyObject(logs)) {
      return Object.keys(logs).map(key => {
        
        let logArr = logs[key].split(",");
        let no = Number.parseInt(key, 10) + 1;
        let logDate = logArr[0];
        let logTime = logArr[1];
        
        return(
          <TableRow key={key}>
            <TableRowColumn>{no}</TableRowColumn>
            <TableRowColumn>{logDate}</TableRowColumn>
            <TableRowColumn>{logTime}</TableRowColumn>
          </TableRow>
        );
        
      })
    }
  }
  
  _changeTab(tabId) {
    this.setState({ currentTab: tabId });
  }
}

const mapStateToProps = state => ({
  fetchSuccess: state.rootReducer.log.fetchSuccess,
  loading: state.rootReducer.log.loading,
  logs: state.rootReducer.log.all
});

export default connect(mapStateToProps, {
  fetchLogsByDeviceId,
})(DeviceLogsChart);


// WEBPACK FOOTER //
// ./src/common/components/DeviceLogsChart/DeviceLogsChart.js